"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Select = void 0;
const react_1 = __importStar(require("react"));
const native_1 = require("styled-components/native");
const icons_1 = require("../icons");
const RadioButton_1 = require("../RadioButton/RadioButton");
const Typography_1 = require("../Typography/Typography");
const Select_styles_1 = require("./Select.styles");
exports.Select = ({ testID, options, onChange, selectedOption = '', ref, disabled = false, error = false, success = false, accessibilityLabel, accessibilityHint, placeholder, dropDownPositionAtBottom = false, ...props }) => {
    const [showOptions, setShowOptions] = react_1.useState(false);
    const [active, setActive] = react_1.useState(false);
    const theme = native_1.useTheme();
    const onSelectFocus = () => {
        setActive(true);
    };
    const onSelectBlur = () => {
        setActive(false);
    };
    const showShowSelectedOption = selectedOption && !showOptions;
    const onOptionPress = (value) => {
        onChange(value);
        setShowOptions(false);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Select_styles_1.Dropdown, Object.assign({ onPress: () => setShowOptions(!showOptions), error: !!error, success: success, active: active, disabled: disabled, accessible: true, accessibilityLabel: `Enter ${accessibilityLabel}`, accessibilityHint: accessibilityHint, testID: testID, onFocus: onSelectFocus, onBlur: onSelectBlur }, props),
            showShowSelectedOption ? (react_1.default.createElement(Typography_1.PText, { type: Typography_1.PTextType.LEAD, color: theme.bpCore.colors.dark[700] }, selectedOption)) : (react_1.default.createElement(Typography_1.PText, { type: Typography_1.PTextType.LEAD, color: theme.bpCore.colors.dark[100] }, placeholder)),
            showOptions ? react_1.default.createElement(icons_1.ChevronUp, null) : react_1.default.createElement(icons_1.ChevronDown, null)),
        showOptions && (react_1.default.createElement(Select_styles_1.OptionsContainer, { testID: `${testID}-options`, dropDownPositionAtBottom: dropDownPositionAtBottom }, options.map((value) => (react_1.default.createElement(Select_styles_1.Option, { testID: value, key: value, onPress: () => onOptionPress(value) },
            react_1.default.createElement(Typography_1.PText, { type: Typography_1.PTextType.LEAD, color: selectedOption === value
                    ? theme.bpCore.colors.dark[700]
                    : theme.bpCore.colors.dark[100] }, value),
            react_1.default.createElement(RadioButton_1.RadioButton, { onPress: () => onOptionPress(value), selected: selectedOption === value }))))))));
};
